import { Stack, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { Calendar } from "../../../pages/Schedule/Schedule/Calendar";
import { ITopMedScheduleItemProps } from "./models";
import { Actions } from "../Actions/Actions";

const TopMedScheduleItem = ({ data, onRefresh }: ITopMedScheduleItemProps) => {
  const navigate = useNavigate();

  const onClickHandler = () => {
    navigate(``);
  };

  return (
    <Stack
      sx={(t) => ({
        flexDirection: "row",
        gap: t.spacing(2),
        padding: t.spacing(2),
        backgroundColor: t.palette.divider,
        borderRadius: t.shape.borderRadius / 2,
      })}
      onClick={onClickHandler}
    >
      <Calendar date={data.date} />
      <Stack
        sx={(t) => ({
          justifyContent: "space-between",
          flexGrow: 1,
          padding: t.spacing(1),
          flex: 1,
        })}
      >
        <Stack
          sx={(t) => ({
            mb: t.spacing(2),
            flexDirection: "column",
            gap: t.spacing(1),
          })}
        >
          <Typography style={{ flex: 1, fontWeight: "500" }}>
            {data.patientName}
          </Typography>
          <Typography style={{ fontSize: 15 }}>{data.name}</Typography>
        </Stack>
        <Actions props={data} onRefresh={onRefresh} />
      </Stack>
    </Stack>
  );
};

export default TopMedScheduleItem;
